import { configureStore } from '@reduxjs/toolkit';

import createSagaMiddleware, { Saga } from 'redux-saga';

import { configureApi } from './api';

import { globalSlice } from './containers/App/reducer';
import globalSaga from './containers/App/sagas';

import homeSaga from './containers/HomePage/sagas';
import registerSaga from './containers/RegisterPage/sagas';
import { statReducer } from './containers/StatPage/reducer';
import statSaga from './containers/StatPage/sagas';
import resetSaga from './containers/ResetPass/sagas';
import confirmSaga from './containers/ConfirmPage/sagas';
import userProfileSaga from './containers/UserProfilePage/sagas';
import { topPlayersReducer } from './containers/TopPlayersPage/reducer';
import topPlayersSaga from './containers/TopPlayersPage/sagas';
import { usersReducer } from './containers/UsersPage/reducer';
import usersSaga from './containers/UsersPage/sagas';
import { userReducer } from './containers/UserPage/reducer';
import userSaga from './containers/UserPage/sagas';
import { referralReducer } from './containers/ReferralPage/reducer';
import referralSaga from './containers/ReferralPage/sagas';
import { adminReferralsReducer } from './containers/AdminReferralsPage/reducer';
import adminReferralsSaga from './containers/AdminReferralsPage/sagas';
import { parserErrorsReducer } from './containers/ParserErrorsPage/reducer';
import parserErrorsSaga from './containers/ParserErrorsPage/sagas';
import { analyticsReducer } from './containers/AdminHomePage/reducer';
import analyticsSaga from './containers/AdminHomePage/sagas';
import { miningUploadReducer } from './containers/MiningUploadPage/reducer';
import miningUploadSaga from './containers/MiningUploadPage/sagas';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    [globalSlice.name]: globalSlice.reducer,
    [statReducer.name]: statReducer.reducer,
    [topPlayersReducer.name]: topPlayersReducer.reducer,
    [usersReducer.name]: usersReducer.reducer,
    [userReducer.name]: userReducer.reducer,
    [referralReducer.name]: referralReducer.reducer,
    [adminReferralsReducer.name]: adminReferralsReducer.reducer,
    [parserErrorsReducer.name]: parserErrorsReducer.reducer,
    [analyticsReducer.name]: analyticsReducer.reducer,
    [miningUploadReducer.name]: miningUploadReducer.reducer,
  },
  devTools: true,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActionPaths: ['meta.arg', 'meta.baseQueryMeta', 'payload.upload'],
      },
    }).prepend(sagaMiddleware),
});

configureApi(sagaMiddleware);
sagaMiddleware.run(globalSaga as Saga);
sagaMiddleware.run(homeSaga);
sagaMiddleware.run(registerSaga);
sagaMiddleware.run(resetSaga);
sagaMiddleware.run(confirmSaga);
sagaMiddleware.run(statSaga);
sagaMiddleware.run(userProfileSaga);
sagaMiddleware.run(topPlayersSaga);
sagaMiddleware.run(usersSaga);
sagaMiddleware.run(userSaga);
sagaMiddleware.run(referralSaga);
sagaMiddleware.run(adminReferralsSaga);
sagaMiddleware.run(parserErrorsSaga);
sagaMiddleware.run(analyticsSaga);
sagaMiddleware.run(miningUploadSaga);

export type RootState = ReturnType<typeof store.getState>;
export default store;
